import React from 'react';
import { Field } from 'redux-form';

const ModifierInputWithoutValidation = props => {
  return (
    <div className="form-group">
      <input type="text" {...props} {...props.input} />
    </div>
  );
};

const ModifierOptionsField = props => {
  const { member, disabled } = props;
  return (
    <div className="mk-grouped-input">
      <div className="form-group col-sm-8">
        <Field
          name={`${member}.name`}
          component={ModifierInputWithoutValidation}
          className="form-control"
          placeholder="Name"
          disabled={disabled}
        />
      </div>
      <div className="form-group col-sm-4">
        <Field
          name={`${member}.price`}
          component={ModifierInputWithoutValidation}
          disabled={disabled}
          positiveNumberOnly
          maxFractionDigits={3}
          placeholder="Rp. 0"
          onChange={e => {
            if (isNaN(e.target.value)) {
              e.preventDefault();
            }
          }}
          className="form-control"
        />
      </div>
    </div>
  );
};

export default ModifierOptionsField;
